'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '@/lib/store';
import { getProfileCompletion } from '@/lib/profile-utils';
import Loader from '@/components/Loader';

export default function Home() {
  const router = useRouter();
  const { isAuthenticated, isLoading, user } = useAuthStore();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        const { actualProgress } = getProfileCompletion(user);
        router.push(actualProgress >= 80 ? '/dashboard' : '/create-clone');
      } else {
        router.push('/login');
      }
    }
  }, [isAuthenticated, isLoading, router, user]);

  return <Loader text="Loading..." />;
}
